module.exports = __webpack_public_path__ + "img/spinner.5960d54f.svg";